import React from 'react';

const FloatingAI = ({ onOpenAIChatPrompt }) => {
  return (
    <button 
      className="floating-ai-assistant"
      onClick={() => onOpenAIChatPrompt()}
      title="Assistant IA"
    >
      🤖
    </button>
  );
};

export default FloatingAI;
